
import { defineComponent, ref, watch } from 'vue';
import LoadingSpinner from '../../components/loading/LoadingSpinner.vue';
import { translate } from '@elements/translations';
import {useOnClickOutside} from "../../composables/click-outside";

export default defineComponent({
    components: {
        LoadingSpinner
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close'],
    setup(props, { emit }) {
        const modalRef = ref(null);
        const showModal = ref(false);
        const loading = ref(true);
        const error = ref(false);

        watch(
            () => props.show,
            onShow => {
                showModal.value = onShow;
                if(onShow) {
                    document.body.classList.add("body--edit-modal-open");
                }
            },
        );

        const onClose = () => {
            showModal.value = false;
            document.body.classList.remove("body--edit-modal-open");
            emit('close');
        };

        const onShow = () => {
            showModal.value = true;
            //set loading
            loading.value = true;
        };

        return {
            modalRef,
            showModal,
            loading,
            error,
            onClose,
            onShow,
            translate
        };
    }
});
